import axios from 'axios';
import apiConfig from '../api.config';

export default function languagesRequest() {
  const {
    host,
    URIs: { languages },
  } = apiConfig;

  const uri = `${host}${languages}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
